import { getStoredHostSession } from "./webAuth";

// These are email-suppression hints from the signed-in user's own browser,
// never evidence for billing, permissions, or the number of real people.
export type EmailMilestone = "remote_controlled" | "preview_enabled" | "team_intent";
const recorded = new Set<string>();
export async function recordEmailMilestone(milestone: EmailMilestone, deckId?: string | null): Promise<void> {
  const session = getStoredHostSession();
  const base = process.env.REACT_APP_QA_API_URL;
  if (!session || !base) return;
  const key = `${session.sessionToken}:${milestone}:${deckId ?? ""}`;
  if (recorded.has(key)) return;
  recorded.add(key);
  try {
    const response = await fetch(`${base}/account/milestone`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${session.sessionToken}` },
      // The zone lets the onboarding emails arrive on a weekday morning there.
      body: JSON.stringify({ milestone, deckId, timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }),
    });
    if (!response.ok) recorded.delete(key);
  } catch { recorded.delete(key); }
}
